import {Component} from '@angular/core';
import {MatSnackBarRef} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {PrivacyDialogComponent} from '../privacy-dialog/privacy-dialog.component';

@Component({
  selector: 'app-privacy-snackbar',
  templateUrl: './privacy-snackbar.component.html',
  styleUrls: ['./privacy-snackbar.component.scss']
})
export class PrivacySnackbarComponent {

  constructor(private snackbarRef: MatSnackBarRef<PrivacySnackbarComponent>, private dialog: MatDialog) { }

  public close() {
    this.snackbarRef.dismiss();
  }

  public openPrivacyDialog() {
    this.dialog.open(PrivacyDialogComponent);
    this.close();
  }
}
